import React from 'react';

import classnames from 'classnames';

import { SORTING_MODES } from '../../../utils';
import { Icon } from '../../Icon';
import { TableExtraColumn } from '../Table.constants';
import { getColStyle } from '../Table.helpers';
import { type ColumnConfig } from '../Table.types';

import styles from '../Table.module.scss';

export type TableHeadColumnProps<RecordType> = {
    column: ColumnConfig<RecordType>;
    sortKey?: string | null;
    sortMode?: SORTING_MODES;
    onSortBy?: (key: string) => void;
};

export const TableHeadColumn = <RecordType,>({
    column,
    sortKey,
    sortMode = SORTING_MODES.NORMAL,
    onSortBy
}: TableHeadColumnProps<RecordType>) => {
    const { title, key, renderTitle, sortable } = column;

    const handleClickSortBy = () => sortable && onSortBy?.(key);

    return (
        <th
            className={classnames({
                [styles.scrollbarCol]: key === TableExtraColumn.Scrollbar,
                [styles.expandButtonCol]: column.key === TableExtraColumn.Expand,
                [styles.sortable]: sortable
            })}
            style={getColStyle(column)}
            onClick={handleClickSortBy}
        >
            {renderTitle ? renderTitle(title, column) : title}
            {sortable && (
                <Icon
                    className={styles.sortIcon}
                    color={key === sortKey ? 'link' : 'base'}
                    aria-label={sortMode}
                    name={
                        sortMode === SORTING_MODES.NORMAL ? 's-icon-arrow-down' : 's-icon-arrow-up'
                    }
                />
            )}
        </th>
    );
};
